import React from "react";
import { Container, NotFound } from "../components";

function Error() {
  return (
    <Container>
      <NotFound />
    </Container>
  );
}

export default Error;
